export default __webpack_public_path__ + "static/media/ENTRY_BLOCK.127355cd.svg";